import React, { useState } from 'react';
import { View } from 'react-native';

import RelayTable from 'app/src/elements/Table/RelayTable';
import { Title, Text } from 'app/src/styles';
import { Link } from 'app/src/utils/routing';

import { EVENT_TYPES } from './queries';

const columns = [
  {
    key: 'name',
    label: 'Name',
  },
  {
    key: 'parent',
    label: 'Parent',
    sort: 'prevent',
    value: ({ value }) => value?.name,
    content: ({ entry, value }) => (
      value && (
        <Link to={`/event-types/${entry.parent.id}`}>
          <Text>{value}</Text>
        </Link>
      )
    ),
  },
  {
    key: 'emoji',
    label: 'Emoji',
  },
  {
    key: 'actions',
    sort: 'prevent',
    content: ({ entry }) => (
      <Link to={`/event-types/${entry.id}`}>
        <Text>View/Edit</Text>
      </Link>
    ),
  }
];

const EventTypes = () => {
  const [refetch, setRefetch] = useState();

  return (
    <View>
      <Title>Event Types</Title>

      <Link to="/event-types/new">
        <Text>Add Event Type</Text>
      </Link>

      <RelayTable
        query={EVENT_TYPES}
        queryName="eventTypes"
        columns={columns}
        setRefetch={setRefetch}
      />
    </View>
  );
};

export default EventTypes;
